import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana78Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1462_13001)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M467.909 330.123L480.306 358.638L436.914 379.714L419.557 343.761L449.312 328.883C458.238 322.932 465.429 327.23 467.909 330.123Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M382.363 361.119L419.552 343.762L436.91 379.715L393.518 400.791C389.798 392.94 382.859 379.467 379.883 373.516C376.908 367.565 380.297 362.772 382.363 361.119Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M496.426 393.351L480.309 358.638L436.917 379.714L454.274 415.667L496.426 393.351Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M410.88 437.985L454.272 415.669L436.915 379.716L393.523 400.792L410.88 437.985Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M426.995 473.938L410.877 437.985L454.27 415.669L471.627 451.622L426.995 473.938Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M513.781 430.546L496.424 393.353L454.272 415.669L471.629 451.622L513.781 430.546Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M443.111 509.889L426.994 473.935L471.626 451.619L487.743 487.573L443.111 509.889Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M531.136 466.497L487.744 487.574L471.627 451.62L513.779 430.544L531.136 466.497Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M547.257 501.213L531.14 466.499L487.748 487.575L505.104 523.529L547.257 501.213Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M460.472 545.845L505.104 523.529L487.747 487.575L443.115 509.891L460.472 545.845Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M476.587 581.797L460.47 545.843L505.102 523.527L521.219 559.481L476.587 581.797Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M564.612 537.166L547.255 501.213L505.103 523.529L521.22 559.482L564.612 537.166Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M581.968 574.359L564.611 537.166L521.219 559.482L538.576 595.436L581.968 574.359Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M495.183 617.751L476.586 581.797L521.218 559.481L538.575 595.435L495.183 617.751Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M507.582 643.789L495.184 617.753L538.576 595.438L555.933 631.391C548.081 635.524 530.146 644.781 521.219 648.748C512.293 652.715 509.235 647.095 507.582 643.789Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M591.884 614.032L555.931 631.389L538.574 595.436L581.966 574.359L595.604 601.634C597.587 608.577 593.951 612.792 591.884 614.032Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_13001" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_13001" transform="matrix(0.00170059 0 0 0.00225449 -3.3984 -1.30587)"/>
    </pattern>
    <image id="image0_1462_13001" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};